import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../button/button.module';
import { FieldModule } from '../field/field.module';
import { DateBoxComponent } from './date-box.component';

import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    FieldModule,
    ButtonModule,
  ],
  declarations: [DateBoxComponent],
  exports: [DateBoxComponent],
})
export class DateBoxModule {}
